import { createFileRoute, redirect } from '@tanstack/react-router';

// Gli Appunti sono una voce di menu dal 21-10-2026. Tiene vivi i vecchi link.
export const Route = createFileRoute('/_app/tasks/notes')({
  beforeLoad: () => { throw redirect({ to: '/notes', replace: true }); },
});
